import FormattedMessage from 'I18n/components/FormattedMessage';
import { BreezeIcon, LayoutHorizontal } from 'breeze-intelligence-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PoweredBy = () => /*#__PURE__*/_jsxs(LayoutHorizontal, {
  as: "span",
  gap: "space-xs",
  children: [/*#__PURE__*/_jsx(BreezeIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dataTest.panel.poweredBy"
  })]
});